import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnchorModule } from '@epicuro-next/ataraxia/anchor';
import { AtaraxiaPageMenuModule } from '@epicuro-next/ataraxia/page-menu';
import { DataMerchandiseModule } from '@epicuro-next/data/merchandise';
import { LetDirective, PushPipe } from '@ngrx/component';

import { SecondaryNavigationBarComponent } from './components/secondary-navigation-bar/secondary-navigation-bar.component';

@NgModule({
  imports: [
    CommonModule,
    LetDirective,
    PushPipe,
    AtaraxiaPageMenuModule,
    AnchorModule,
    DataMerchandiseModule,
  ],
  declarations: [SecondaryNavigationBarComponent],
  exports: [SecondaryNavigationBarComponent],
})
export class SecondaryNavigationBarModule {}
